import { useContext, useSyncExternalStore } from "react"
import { ReactReduxContext } from "react-redux"

import { getPermissionValueAtPath } from "../../../../../components/PermissionGate/PermissionGate.tsx"
import type { RootState } from "../../../../../store.ts"
import { isAiToolAvailable } from "../../../ai-center-availability.ts"

const VIEW = "ai_center.sow_receivables.sow_receivables_view"
const CREATE = "ai_center.sow_receivables.sow_receivables_create"
const NONE = { canView: false, canStart: false }
const noStore = () => () => undefined

const accessOf = (state: RootState | undefined) => {
  const auth = state?.auth
  const codes = auth?.permissions?.codes
  const canView =
    auth?.userInfo?.feature_ai_center === true &&
    isAiToolAvailable("customer-sow-receivables") &&
    Boolean(getPermissionValueAtPath(codes, VIEW))
  return canView
    ? `view${getPermissionValueAtPath(codes, CREATE) ? "+start" : ""}`
    : "none"
}

/** Whether Full Project Execution is offered to this user anywhere in the app: the
 *  AI Center is on for the company, the tool is released, and the user holds its View
 *  right (Create to start a plan). Every entry point reads this one answer. Outside a
 *  store (a component rendered on its own) nothing is offered. */
export function useFpeAccess() {
  const context = useContext(ReactReduxContext)
  const store = context?.store
  const access = useSyncExternalStore(store ? store.subscribe : noStore, () =>
    accessOf(store?.getState() as RootState | undefined)
  )
  if (access === "none") return NONE
  return { canView: true, canStart: access === "view+start" }
}
